import { focusOnLogo } from "@garantidos/utils"

const useSoftleadOneClick = () => {
  const setTrackingBackHome = (currentStep) => {
    focusOnLogo()

    const el = document.getElementById("main-logo")
    el.onclick = () => trackers.backHome(hashedCpf, currentStep)
  }

  return { setTrackingBackHome }
}

export default useSoftleadOneClick
